if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    connectedCallback() {
      const videoId = this.getAttribute('data-id')

      // Used to detach event listeners
      this.abortController = new AbortController()

      if (!videoId) {
        return
      }

      this.video = document.getElementById(videoId)

      if (!this.video) {
        return
      }

      this.playButton = this.querySelector('[data-play]')
      this.muteButton = this.querySelector('[data-mute]')

      this.bindEvents()
    }

    bindEvents() {
      if (this.muteButton) {
        this.muteButton.setAttribute('aria-pressed', this.video.muted)
        this.muteButton.addEventListener(
          'click',
          this.handleMuteButtonClick.bind(this),
          { signal: this.abortController.signal }
        )
      }

      if (this.playButton) {
        this.syncPlayButton()
        this.playButton.addEventListener(
          'click',
          this.handlePlayButtonClick.bind(this),
          { signal: this.abortController.signal }
        )
        this.video.addEventListener('play', this.syncPlayButton.bind(this), {
          signal: this.abortController.signal,
        })
        this.video.addEventListener('pause', this.syncPlayButton.bind(this), {
          signal: this.abortController.signal,
        })
      }
    }

    syncPlayButton() {
      this.playButton.setAttribute('aria-pressed', !this.video.paused)
    }

    // Mute / unmute
    handleMuteButtonClick() {
      this.video.muted = !this.video.muted
      this.muteButton.setAttribute('aria-pressed', this.video.muted)
    }

    // Play / pause
    handlePlayButtonClick() {
      if (this.video.paused) {
        this.video.play()
      } else {
        this.video.pause()
      }
    }

    disconnectedCallback() {
      this.abortController.abort()
    }
  }

  customElements.define('video-controls', VideoControls)
}
